import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import {
  TextInput,
  required,
  AutocompleteInput,
  CreateProps,
  minLength,
  Record,
  useGetList,
} from 'react-admin'

import { Grid, Paper, Button, Typography, makeStyles } from '@material-ui/core'

import { numberValidate } from 'utils/formValidations'
import { ResourceSelectorEdit, DatetimePicker } from 'components'
import * as actions from 'customReducers/lessonReducer/actions'

import { Tooltip } from 'components'
import { AsidePreview } from '../AsidePreview'

import { useGetMany } from 'react-admin';

import { useRecordContext } from 'react-admin';

const useStyles = makeStyles({
  container: {
    width: '100%',
  },
  formContainer: {
    backgroundColor: '#F5F5F5',
  },
  paperContainer: {
    padding: 16,
  },
  buttonsContainer: {
    padding: 8,
  },
  gridContainer: {
    width: '100%',
    margin: 0,
    padding: 0,
  },
})
interface ExtendedCreateProps extends CreateProps {
  toolbar: React.ReactElement
  aside?: React.ReactElement
  formData?: any
}

export const EditForm = (props: ExtendedCreateProps) => {
  const dispatch = useDispatch()
  const classes = useStyles()
  const { toolbar, aside = <></>, formData, ...rest } = props

  const [tags, setTags] = useState<any>([])
  const [attachments, setAttachments] = useState<any>([1])
  const [involvedPersons, setInvolvedPersons] = useState<any>([1])
  const record = useRecordContext();

  const [tagsData, setTagsData] = useState<Record[]>([])
  const [showTags, setShowTags] = useState<boolean>(false)
  
  const [allTagsLoaded, setAllTagsLoaded] = useState<Record[]>([])

  const { data: loadedTags, loading: isLoadingRecordTags } = useGetMany('cms/content/tags',
    record?.contents ? record?.contents?.tags.map((tag: { id: string }) => { return tag.id; }) : [],
      // { enabled: record && record.tags && record.tags.length > 0 }
    );

  const { data: allTags, loading: isLoadingAllTags } = useGetList('cms/content/tags', 
    { page: 1, perPage: 5000 },
    { field: 'name', order: 'ASC' }
  );

  const loadTags = () => {
    if (loadedTags && loadedTags[0]?.id) {
      setShowTags(true);
      setTagsData(loadedTags);
    }

    return null;
  }

  useEffect(() => {
    loadTags();
  }, [loadedTags]);

  useEffect(() => {
    const allTagsArr = Object.entries(allTags).map((value) => {
      return value[1];
    });
    setAllTagsLoaded(allTagsArr);
  }, [allTags]);

  useEffect(() => {
    loadTags();
  }, []);

  useEffect(() => {
    if (formData && Object.keys(formData).length && formData?.id) {
      // dispatch(actions.updateFormData(formData));
      setTags(formData?.contents?.tags?.length ? formData?.contents?.tags : [1])
      setAttachments(
        formData?.contents?.attachments?.length
          ? formData?.contents?.attachments
          : [1],
      )
      setInvolvedPersons(
        formData?.contents?.involved_people?.length
          ? formData?.contents?.involved_people
          : [1],
      )
    }
  }, [formData])

  return (
    <>
      <AsidePreview />

      <Grid
        container
        direction="row"
        justifyContent="center"
        alignItems="center"
        spacing={2}
        className={classes.gridContainer}
      >
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <Paper className={classes.paperContainer}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Typography variant="h5" color="textSecondary" gutterBottom>
                {`${!formData?.id ? 'Inserir Nova' : 'Editar'} Aula`}
              </Typography>
              <hr />
              <Typography
                variant="subtitle1"
                color="textPrimary"
                gutterBottom
              >{`Configurações: `}</Typography>
            </Grid>
            <Grid
              container
              spacing={2}
              className={classes.gridContainer}
              direction="column"
            >
              <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                <Typography
                  variant="subtitle2"
                  color="textPrimary"
                >{`Para a Semana: `}</Typography>
                <Typography variant="caption" color="textSecondary">
                  {` Digite uma parte do nome da semana que você deseja vincular.`}
                </Typography>
                <hr />
                <Typography variant="caption" color="textSecondary">
                  {` Para CRIAR uma Semana visite Conteúdo > Semanas.`}
                </Typography>
                <Tooltip title={'lessons.weeks_id'}>
                  <div>
                    <ResourceSelectorEdit
                      fullWidth
                      label="Semana"
                      resource="cms/grouper/week"
                      source={`grouper_id`}
                      optionValue="id"
                      validate={[required('Obrigatório')]}
                      selectedValue={formData?.grouper_id}
                    />
                  </div>
                </Tooltip>
              </Grid>
              <Grid container direction="row" spacing={3}>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <Tooltip title={'lessons.released_at'}>
                    <div>
                      <DatetimePicker
                        fullWidth
                        source="released_at"
                        label="Lançamento"
                        defaultValue={formData?.released_at}
                        validate={[required('Obrigatório')]}
                      />
                    </div>
                  </Tooltip>
                </Grid>

                <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                  <Tooltip title={'lessons.order'}>
                    <TextInput
                      fullWidth
                      label="Ordem"
                      source="order"
                      validate={[
                        required('Obrigatório'),
                        numberValidate,
                        minLength(2, 'Mínimo 2 caracteres numéricos'),
                      ]}
                    />
                  </Tooltip>
                </Grid>
              </Grid>

              <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
                <Tooltip title={'lessons.status'}>
                  <div>
                    <AutocompleteInput
                      fullWidth
                      label="Status da Aula"
                      source="status"
                      choices={[
                        {
                          id: 'concluido',
                          name: 'Publicada',
                        },
                        {
                          id: 'pendente',
                          name: 'Pendente',
                        }
                      ]}
                      validate={[required('Obrigatório')]}
                    />
                  </div>
                </Tooltip>
              </Grid>

              <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
                <Tooltip title={'lessons.type'}>
                  <div>
                    <AutocompleteInput
                      fullWidth
                      label="Tipo de Aula"
                      source="type"
                      choices={[
                        {
                          id: 'enterprising',
                          name: 'Aula com Empreendedor',
                        },
                        {
                          id: 'techniques',
                          name: 'Aula com o Especialista',
                        },
                        { id: 'liveclass', name: 'Liveclass' },
                        { id: 'documentary', name: 'Documentário' },
                        { id: 'extra', name: 'Aula Extra' },
                      ]}
                      validate={[required('Obrigatório')]}
                    />
                  </div>
                </Tooltip>
              </Grid>

              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <Tooltip title={'lessons.title'}>
                  <TextInput
                    fullWidth
                    label="Título"
                    source="title"
                    validate={[required('Obrigatório')]}
                  />
                </Tooltip>
              </Grid>

              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <Typography
                  variant="subtitle2"
                  color="textPrimary"
                >{`Para o Autor: `}</Typography>
                <Typography variant="caption" color="textSecondary">
                  {` Digite uma parte do nome da pessoa que você deseja vincular.`}
                </Typography>
                <hr />
                <Typography variant="caption" color="textSecondary">
                  {` Para CRIAR um Autor visite Conteúdo > Pessoas.`}
                </Typography>
                <Tooltip title={'lessons.autor_id'}>
                  <div>
                    <ResourceSelectorEdit
                      fullWidth
                      label="Autor"
                      source={`contents.involved_people[0].id`}
                      resource="cms/content/involved_people"
                      optionValue="id"
                      searchField="name"
                      selectedValue={involvedPersons?.[0]?.id}
                      filter={{
                        type: 'autor',
                      }}
                    />
                  </div>
                </Tooltip>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>

      <Grid
        container
        direction="row"
        justifyContent="center"
        alignItems="center"
        spacing={2}
        className={classes.gridContainer}
      >
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <Paper className={classes.paperContainer}>
            <Grid
              container
              spacing={2}
              className={classes.gridContainer}
              direction="column"
            >
              <Typography
                variant="subtitle1"
                color="textPrimary"
                gutterBottom
              >{`Conteúdo: `}</Typography>

              <Grid container spacing={2} direction="column">
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <Typography
                    variant="subtitle2"
                    color="textPrimary"
                  >{`Para o Vídeo: `}</Typography>
                  <Typography variant="caption" color="textSecondary">
                    {` Digite uma parte do nome do vídeo que você deseja vincular.`}
                  </Typography>
                  <Tooltip title={'lessons.video_id'}>
                    <div>
                      <ResourceSelectorEdit
                        fullWidth
                        label="Video da Aula"
                        resource="cms/content/videos"
                        source={`contents.videos[0].id`}
                        optionValue="id"
                        choicesFilter={{
                          target: 'type',
                          operator: 'odd',
                          filter: 'trailer',
                        }}
                        selectedValue={formData?.contents?.videos?.[0]?.id}
                      />
                    </div>
                  </Tooltip>
                </Grid>
                <Grid item xs={12} sm={12} md={5} lg={5} xl={5}>
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={() => dispatch(actions.videosDialog())}
                  >
                    Adicionar Novo Vídeo
                  </Button>
                  <hr />
                </Grid>
              </Grid>

              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <Tooltip title={'lessons.description'}>
                  <TextInput
                    fullWidth
                    label="Descrição"
                    source="description"
                    validate={[required('Obrigatório')]}
                    multiline
                  />
                </Tooltip>
              </Grid>

              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <hr />
              </Grid>
              <Typography
                variant="subtitle1"
                color="textPrimary"
                gutterBottom
              >{`Sumário: `}</Typography>

              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <Tooltip title={'lessons.summary.summary'}>
                  <TextInput
                    fullWidth
                    label="Sumário"
                    source="summary"
                    validate={[required('Obrigatório')]}
                    multiline
                  />
                </Tooltip>
              </Grid>
            </Grid>

            <Grid container direction="column">
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <hr />
              </Grid>
              <Typography
                variant="subtitle1"
                color="textPrimary"
                gutterBottom
              >{`Materiais Complementares: `}</Typography>

              <Typography
                variant="subtitle2"
                color="textPrimary"
              >{`Para o Anexo: `}</Typography>
              <Typography variant="caption" color="textSecondary">
                {` Digite uma parte do nome do Anexo que você deseja vincular.`}
              </Typography>
              <Grid container spacing={2} className={classes.gridContainer}>
                {attachments &&
                  !!attachments.length &&
                  attachments.map((item: any, index: number) => {
                    return (
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        md={6}
                        lg={6}
                        xl={6}
                        key={index}
                      >
                        <Tooltip title={'lessons.attachments_id'}>
                          <div>
                            <ResourceSelectorEdit
                              fullWidth
                              label={`Anexo`}
                              resource="cms/content/attachments"
                              source={`contents.attachments[${index}].id`}
                              optionValue="id"
                              selectedValue={
                                formData?.contents?.attachments?.[index]?.id
                              }
                            />
                          </div>
                        </Tooltip>
                      </Grid>
                    )
                  })}
              </Grid>
              <Grid container spacing={2} className={classes.buttonsContainer}>
                <Grid item>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() =>
                      setAttachments([...attachments, attachments.length + 1])
                    }
                  >
                    Vincular outro Anexo
                  </Button>
                </Grid>

                <Grid item>
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={() => dispatch(actions.attachmentsDialog())}
                  >
                    Criar Novo Anexo
                  </Button>
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <hr />
            </Grid>

            <Grid
              spacing={2}
              direction="column"
              container
              className={classes.gridContainer}
            >
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Typography
                  variant="subtitle1"
                  color="textPrimary"
                  gutterBottom
                >{`Pessoas envolvidas: `}</Typography>
              </Grid>
              <Typography
                variant="subtitle2"
                color="textPrimary"
              >{`Para a Pessoa: `}</Typography>
              <Typography variant="caption" color="textSecondary">
                {` Digite uma parte do nome da Pessoa que você deseja vincular.`}
              </Typography>
              <Grid spacing={2} direction="row" container>
                {!!involvedPersons.length &&
                  involvedPersons
                    .slice(involvedPersons.length > 1 ? 1 : 0)
                    .map((item: any, index: number) => (
                      <Grid
                        key={index}
                        item
                        xs={12}
                        sm={12}
                        md={6}
                        lg={4}
                        xl={3}
                      >
                        <Tooltip title={'lessons.involved_people'}>
                          <div>
                            <ResourceSelectorEdit
                              fullWidth
                              label="Pessoa"
                              resource="cms/content/involved_people"
                              source={`contents.involved_people[${
                                index + 1
                              }].id`}
                              optionValue="id"
                              selectedValue={item?.id}
                            />
                          </div>
                        </Tooltip>
                      </Grid>
                    ))}

                <Grid
                  item
                  container
                  spacing={2}
                  className={classes.buttonsContainer}
                >
                  <Grid item>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() =>
                        setInvolvedPersons([
                          ...involvedPersons,
                          involvedPersons.length + 1,
                        ])
                      }
                    >
                      Vincular outra Pessoa
                    </Button>
                  </Grid>

                  <Grid item>
                    <Button
                      variant="outlined"
                      color="primary"
                      onClick={() => dispatch(actions.personsDialog())}
                    >
                      Criar Nova Pessoa
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <hr />
            </Grid>

            <Grid
              spacing={2}
              direction="column"
              container
              className={classes.gridContainer}
            >
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Typography
                  variant="subtitle1"
                  color="textPrimary"
                  gutterBottom
                >{`Tags: `}</Typography>
              </Grid>
              <Typography
                variant="subtitle2"
                color="textPrimary"
              >{`Para a Tag: `}</Typography>
              <Typography variant="caption" color="textSecondary">
                {` Digite uma parte do nome da Tag que você deseja vincular.`}
              </Typography>
              <Grid container>
                {showTags && tagsData.map((tag: Record, index: number) => (
                  <Grid
                    xs={12}
                    sm={12}
                    md={6}
                    lg={6} xl={6} key={index}>
                    <Tooltip title={'lessons.tags_id'}>
                      <div>
                        <AutocompleteInput
                          key={tag?.id}
                          optionText={(record) => { return record && record.title ? record.title : ''; }}
                          label='Tag'
                          choices={allTagsLoaded}
                          source={`contents.tags[${index}].id`}
                          // onInputValueChange={handleOnInputValueChange}
                          resettable
                          selectedItem={tag}
                          optionValue='id'
                        />
                      </div>
                    </Tooltip>
                  </Grid>
                ))}
                <Grid
                  container
                  spacing={2}
                  className={classes.buttonsContainer}
                >
                  <Grid item>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => { setTagsData([...tagsData, {id: ''}]); }}
                    >Vincular outra Tag</Button>
                  </Grid>
                  <Grid item>
                    <Button
                      variant="outlined"
                      color="primary"
                      onClick={() => dispatch(actions.tagsDialog())}
                    >
                      Criar Nova Tag
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <hr />
            </Grid>
            <Typography
              variant="subtitle1"
              color="textPrimary"
              gutterBottom
            >{`Comentários: `}</Typography>

            <Typography
              variant="subtitle2"
              color="textPrimary"
            >{`Para a Pergunta: `}</Typography>
            <Typography variant="caption" color="textSecondary">
              {` Digite uma parte do nome da Pergunta que você deseja vincular.`}
            </Typography>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
              <Tooltip title={'lessons.comments_question_id'}>
                <div>
                  <ResourceSelectorEdit
                    fullWidth
                    label="Pergunta título"
                    resource="cms/content/comments_titles"
                    source={'contents.comments_titles[0].id'}
                    optionValue="id"
                    validate={[required('Obrigatório')]}
                    selectedValue={formData?.contents?.comments_titles?.[0]?.id}
                  />
                </div>
              </Tooltip>
            </Grid>
            <Grid container spacing={2} className={classes.buttonsContainer}>
              <Grid item>
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={() => dispatch(actions.commentsTitileDialog())}
                >
                  Criar Nova Pergunta
                </Button>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
    </>
  )
}
